import type { ImportRequestSource } from 'services/import-requests/enums'
import type { ImportRequestObjectCounts } from 'services/import-requests/types'

import {
  RequestActivityRequestType,
  ReviewActivityActorType,
  ReviewActivityDecisionOutcome,
  ReviewActivityEventType,
  ReviewActivitySharingOutcome
} from './enums'

export { RequestActivityRequestType, ReviewActivityEventType }

export enum RequestActivityEventType {
  Submitted = 'submitted',
  Assigned = 'assigned',
  PeerReviewed = 'peer-reviewed',
  Unassigned = 'unassigned',
  LabelAdded = 'label-added',
  LabelRemoved = 'label-removed',
  Approved = 'approved',
  Rejected = 'rejected',
  AppealSubmitted = 'appeal-submitted',
  AttestationRequested = 'attestation-requested',
  AttestationSubmitted = 'attestation-submitted',
  DataAccessShared = 'data-access-shared'
}

export interface RequestActivityEvent {
  id: string
  type: RequestActivityEventType
  title: string
  note?: string
  /** ISO timestamp. Undefined when the event has no recorded time. */
  at?: string
}

/**
 * What the card needs from the request to hit the right review-activity path and to fill copy
 * that the event snapshot does not carry (import source/counts, rejection reason).
 */
export interface RequestActivitySource {
  requestType: RequestActivityRequestType
  requestId: string
  rejectionReason?: string
  importSource?: ImportRequestSource
  importCounts?: ImportRequestObjectCounts
}

export interface ReviewActivityUserSnapshot {
  _id?: string
  id?: string
  displayName: string
  email: string
}

export interface ReviewActivityActorSnapshot {
  type: ReviewActivityActorType
  displayName: string
  _id?: string
  id?: string
  email?: string
}

export interface ReviewActivityWorkspaceSnapshot {
  _id: string
  name: string
}

export interface ReviewActivityLabelSnapshot {
  name: string
  _id?: string
  id?: string
}

export interface ReviewActivityEvent {
  _id: string
  eventType: ReviewActivityEventType
  occurredAt: string
  actor: ReviewActivityActorSnapshot
  workspace?: ReviewActivityWorkspaceSnapshot
  previousAssignee?: ReviewActivityUserSnapshot | null
  newAssignee?: ReviewActivityUserSnapshot | null
  reviewConfirmed?: boolean
  label?: ReviewActivityLabelSnapshot
  decision?: { outcome: ReviewActivityDecisionOutcome }
  sharing?: {
    outcome: ReviewActivitySharingOutcome
    workspace: ReviewActivityWorkspaceSnapshot
  }
}

export interface ReviewActivityListResponse {
  data: ReviewActivityEvent[]
  pagination: {
    currentPage: number
    perPage: number
    nextPage?: number | null
    prevPage?: number | null
    totalCount: number
    totalPages: number
  }
}

export interface GetRequestActivityParams {
  requestType: RequestActivityRequestType
  requestId: string
  page?: number
  perPage?: number
}
